import View from './view.js'
import previewView from './previewView.js'
import icons from 'url:../../img/icons.svg'

class bookmarksView extends View {
    _parentElement = document.querySelector('.bookmarks__list');
    _errorMessage = "No bookmarks yet. Find a nice recipe and bookmark it";
    _successMessage = "";

    addRenderHandler(handler) {
        window.addEventListener('load', handler);
    }

    _generateMarkup() {
        // console.log(this._data)
        return this._data.map(bookmark => previewView.render(bookmark, false)).join('');
    }
    //render parameter for render method is set to false, this make the preview View return the markup string and not insert it in the dom

}

export default new bookmarksView();